import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import networkApi from "../api";
import { DnsReport } from "../@types";
import { networkKeys } from "../../samples/queryKeys";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

const { nti_toolkit_enabled: isNtiEnabled } = window.tcbase.consts;

const useDnsReport = (url: string) => {
  const {
    data: dnsData,
    isFetching,
    error
  } = useQuery({
    queryKey: networkKeys.dnsReport(url),
    queryFn: () => networkApi.dnsReport({ url }),
    select: ({ data }: AxiosResponse<DnsReport>) => data,
    enabled: Boolean(url && isNtiEnabled),
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });

  return {
    dnsReport: dnsData,
    isLoadingDnsReport: isFetching,
    error
  };
};

export default useDnsReport;
